module.exports = __webpack_public_path__ + "static/media/Faction_Financial_Terms_and_Conditions.6971b12d.pdf";